import React from "react";
import SaveDraft from "../../../components/candidate/preparation/SaveDraft";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";

function SaveDraftGuide() {
  return (
    <div className="hirePlusPlusPageContent">
      <Sidebar activePage="preparation" userRole="candidate" />
      <div className="w-full hireplusplusRightContent">
        <Topbar activePage="preparation" userRole="candidate" newTitle="Saved Draft"  driverFlag="create-new-draft" />
        <SaveDraft />
      </div>
    </div>
  );
}

export default SaveDraftGuide;
